/**
 * @generated SignedSource<<60e9a0865a48e82ba589dacbb326c395>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetailsAbout_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailItemInvoice_user">;
  readonly " $fragmentType": "PdpRespSidebarDetailsAbout_user";
};
export type PdpRespSidebarDetailsAbout_user$key = {
  readonly " $data"?: PdpRespSidebarDetailsAbout_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsAbout_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetailsAbout_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailItemInvoice_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "1c3c8acfcce192d564859d5b69b557a3";

export default node;
